import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '../views/HomePage.vue';
import MyPage from '../views/MyPage.vue';
import TeamPage from '../views/TeamPage.vue';
import WithdrawalsPage from '../views/WithdrawalsPage.vue';
import DepositPage from '../views/DepositPage.vue';
import OrderPage from '../views/OrderPage.vue';
import OrderDetail from '../views/OrderDetail.vue';
import productDetail from '../views/productDetail.vue';
import HistoryPage from '../views/HistoryPage.vue';
import PostPage from '../views/PostPage.vue';
import PostDetail from '../views/PostDetail.vue';
import i18n from '../i18n';
import { applySeo } from '../utils/seo';


const routes = [
    {
        path: '/',
        name: 'HomePage',
        component: HomePage,
        meta: { seoKey: 'home', noindex: false }
    },
    {
        path: '/my',
        name: 'MyPage',
        component: MyPage,
        meta: { seoKey: 'my', noindex: true }
    },{
        path: '/team',
        name: 'TeamPage',
        component: TeamPage,
        meta: { seoKey: 'team', noindex: true }
    },{
        path: '/withdrawals',
        name: 'WithdrawalsPage',
        component: WithdrawalsPage,
        meta: { seoKey: 'withdraw', noindex: true }
    }
    ,{
        path: '/deposit',
        name: 'DepositPage',
        component: DepositPage,
        meta: { seoKey: 'deposit', noindex: true }
    },{
        path: '/order',
        name: 'OrderPage',
        component: OrderPage,
        meta: { seoKey: 'order', noindex: true }
    },{
        path: '/orderdetail/:id/:product_name/:create_at/:end_at/:arp/:et_arp/:status/:amount',
        name: 'OrderDetail',
        component: OrderDetail,
        meta: { seoKey: 'orderDetail', noindex: true }
    },{
        path: '/productdetail/:id/:name/:arp/:start_funds/:cycle/:describe/:team_arp',
        name: 'productDetail',
        component: productDetail,
        meta: { seoKey: 'product', noindex: false }
    },{
        path: '/history',
        name: 'HistoryPage',
        component: HistoryPage,
        meta: { seoKey: 'history', noindex: true }
    },{
        path: '/post',
        name: 'PostPage',
        component: PostPage,
        meta: { seoKey: 'post', noindex: false }
    },{
        path: '/postdetail/:date/:title/:text',
        name: 'postdetail',
        component: PostDetail,
        meta: { seoKey: 'postDetail', noindex: false }
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior() {
        return { top: 0 };
    }
});

router.afterEach((to) => {
    const key = to.meta.seoKey || 'home';
    const noindex = !!to.meta.noindex;
    let title = i18n.global.t(`seo.${key}.title`);
    let description = i18n.global.t(`seo.${key}.description`);

    if (to.name === 'productDetail' && to.params.name) {
        const name = to.params.name;
        const arp = to.params.arp;
        title = i18n.global.t('seo.product.dynamicTitle', { name, arp });
        description = i18n.global.t('seo.product.dynamicDesc', {
            name,
            arp,
            min: to.params.start_funds,
            days: to.params.cycle
        });
    }
    if (to.name === 'postdetail' && to.params.title) {
        title = `${to.params.title} | ${i18n.global.t('appname')}`;
        description = String(to.params.text || '').slice(0, 140);
    }

    applySeo({
        title,
        description,
        path: noindex ? '/' : to.path,
        noindex
    });
});

export default router;
